
import React, {Component} from 'react';
import { Box } from 'reactjs-admin-lte'
import {connect} from 'react-redux'
import Select from 'react-select'
import {Button,ButtonToolbar,DropdownButton,MenuItem,FormControl} from 'react-bootstrap'
import {Radio,RadioGroup} from 'react-icheck'
import FontAwesome from 'react-fontawesome'
import DatePicker from '../../component/element/DatePicker'
import WorkdocStore from '../../stores/WorkdocStore'
import PaymentNoteDocModal from '../so/PaymentNoteDocModal'
import InputNumber from 'rc-input-number'

var NotificationSystem = require('react-notification-system');
class SWTCreditInstallment extends Component {

  constructor(...args){
    super(...args)

    let unpaid = this.props.messages['Unpaid']
    let already_paid = this.props.messages['Already Paid'] 
    this.state = {
      amount:this.props.amount,
      loading:false,showPNDoc:false,workNo:'',activeIndex:-1,
      btnTitle:this.props.messages['Select Periods'],
      data:{installationType:'same',list:[]},
      optionsStatus:[{value:0,label:unpaid},{value:1,label:already_paid}],
      showAdd:false
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //this.loadCreditInstallation()
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }

  componentWillReceiveProps(newProps){
    
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  updateAmount(amount){
    this.setState({amount:amount})
  }

  loadData(workNo) {
    let {messages} = this.props
    let that = this
    let {data} = this.state
    this.setState({loading:true,workNo:workNo})
    WorkdocStore.loadCreditInstallation(workNo,function(result) {
      let arr = result.data
      let btnTitle = messages['Select Periods'];
      if(result.data.list===undefined){
        arr = {list:[],installationType:'same'}
      }else{
        result.data.list = result.data.list.map((item,index)=>{
          if (item.invoice_type==="cashbill"&&item.payment_note_no)
            delete item['payment_note_no']
          return item
        })
        arr.installationType = (arr.installationType===undefined)?data.installationType:arr.installationType
        if (typeof result.data.numberOfInstallation!=='undefined'&&result.data.numberOfInstallation===-1) {
          btnTitle = 'ไม่ระบุ'
          that.setState({showAdd:true})
        } else {
          btnTitle = messages['Quantity']+' '+arr.list.length+' '+messages['Period']
          that.setState({showAdd:false})
        }  
      }
      that.setState({data:arr,loading:false,btnTitle:btnTitle})
    },function(){
      that.setState({loading:false})
    })
  }
  

  newEmptyRow(number,amount,installationType=''){
    let periodAmount = 0
    if(installationType==='same'){
      periodAmount = Math.ceil(amount/number)
    }
    return new Array(number).fill('').map((item,index)=>{
      
      return {due_date:'',amount:periodAmount,status:0,remark:''}
    })
  }

  onSaveClick(e) {
    
    if(this.props.onSave !==undefined){
      this.props.onSave(()=>{
        this.saveInstallation()
      })
    }else{
      this.saveInstallation()
    }

    
  }

  saveInstallation(){
    let {data,showAdd} = this.state    
    let {messages,formData} = this.props
    this.setState({loading:true})
    if (showAdd) {
      data = Object.assign(data, {numberOfInstallation:-1})
    } else {
      data = Object.assign(data, {numberOfInstallation:data.list.length}) 
    }
    WorkdocStore.saveWorkdocRelated((this.props.name==='installation_component'?formData:this.props.workNo),'creditinstallation',data,(result)=> {
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Saved Successfully'],
          level: 'info',
          position: 'tc'
        });
      }
      this.setState({loading:false})
    },()=>{
      this.setState({loading:false})
    })
  }

  onCloseClick(e) {

  }

  onRowAdd(number) {
    let { data } = this.state
    data.list = data.list.concat(this.newEmptyRow(number,this.state.amount,this.props.installationType))
    this.setState({data:data})
  }

  onMenuItemSelect(key){
    let {data} = this.state
    let {messages} = this.props
    if (key===-1) {
      this.setState({btnTitle:'ไม่ระบุ',showAdd:true})
    } else {
      if (key>data.list.length) {
        let number = key - data.list.length
        
        data.list = data.list.concat(this.newEmptyRow(number,this.state.amount,this.props.installationType))
              
      } else if (key<data.list.length) {
        let number = data.list.length - key
        data.list.splice(key, number);
      }

      if(data.installationType==='same'){
        let periodAmount = Math.ceil(this.state.amount / data.list.length)
        data.list = data.list.map((item,index)=>{
          item.amount = periodAmount
          return item  
        })
      }
      this.setState({btnTitle:messages['Quantity']+' '+ key+' '+messages['Period'],data:data,showAdd:false})
    }  
  }

  onExportItemSelect(item,index,key) {
    this.onEditClick(item,index,(key==='1'?'cashbill':'paymentnote'))
  }

  onStatusChange(index,e) {
    let {data} = this.state
    data.list[index]['status'] = e.value
    this.setState({data:data})
  }

  onDateChange(index,date) {
    let {data} = this.state
    data.list[index]['due_date'] = date
    this.setState({data:data})
  }

  onTextChange(index,key,e) {
    let {data} = this.state
    data.list[index][key] = e.target.value
    this.setState({data:data})
  }

  onNumericChange(index,key,e) {
    let {data} = this.state
    data.list[index][key] = e
    this.setState({data:data})
  }  

  onRadioChange(e,value){
    
    let {data} = this.state
    data.installationType = value
    if(value==='same'){
      
      let periodAmount = Math.ceil(this.state.amount / data.list.length)
      data.list = data.list.map((item,index)=>{
        item.amount = periodAmount
        return item  
      })
      
    }
    this.setState({data:data})
  }

  onPaymentNodeSaved(pnNo,docType){
    let {data,activeIndex} = this.state
    if (docType==='cashbill')
      data.list[activeIndex].cashbill_no = pnNo
    else
      data.list[activeIndex].payment_note_no = pnNo
    data.list[activeIndex] = Object.assign({invoice_type:docType},data.list[activeIndex])
    this.setState({data:data},()=>{
      this.saveInstallation()
    })
  }

  onEditClick(item,index,doc='paymentnote'){
    let {workNo,data} = this.state
    let docNo = (doc==='cashbill'?item.cashbill_no:item.payment_note_no)
    setTimeout(()=>{
      if(docNo!==undefined && docNo!==''){
        this.refs.pnDocM.getWrappedInstance().loadData(docNo,doc)
      }else{      
        this.refs.pnDocM.getWrappedInstance().loadNewDocCreditInstallment(workNo,item,index,data.list.length,doc,()=>{
          //OK
        })
      }
    },100)
    this.setState({showPNDoc:true,activeIndex:index})
  }

  onPrintClick(item){
    let url = ''
    if (item.invoice_type==='cashbill') {
      url = './pdf/?iv='+item.cashbill_no+'&file=cashbill_doc';
      if (process.env.NODE_ENV === "development") {
        url = 'https://demo2.bigfix.co/okorat/pdf/?iv='+item.cashbill_no+'&file=cashbill_doc';
      }
    } else {
      url = './pdf/v2?startPage=PrintPaymentNoteDoc&pn='+item.payment_note_no;
      if (process.env.NODE_ENV === "development") {
        url = '?startPage=PrintPaymentNoteDoc&pn='+item.payment_note_no;
      }
    }
    window.open(url)
  }

  onDelClick(index) {
    let {data} = this.state
    data.list.splice(index,1)
    this.setState({data:data})
  }

  renderBtnDel(index) {
    return(<Button bsStyle='danger' onClick={this.onDelClick.bind(this,index)}><FontAwesome name='trash' /></Button>)
  }

  renderPrintButton(item,index){
    let {showAdd} = this.state
    let docNo = (item.invoice_type==='cashbill'?item.cashbill_no:item.payment_note_no)
    if(docNo!==undefined && docNo!==''){
      return (
        <ButtonToolbar style={{display:'inline-block'}}>
          <Button onClick={this.onEditClick.bind(this,item,index,(item.invoice_type==='cashbill'?'cashbill':'paymentnote'))}><FontAwesome name='pencil' />&nbsp;แก้ไข</Button>
          <Button className='bg-maroon' onClick={this.onPrintClick.bind(this,item)}><FontAwesome name='print' />&nbsp;พิมพ์</Button>
          {showAdd?
          this.renderBtnDel(index)
          :''}
        </ButtonToolbar>
      )
    }else{
      return (
        <ButtonToolbar style={{display:'inline-block'}}>
          <DropdownButton id='dd-export-doc' title={(<span><FontAwesome name='pencil' /> ออกเอกสาร</span>)} onSelect={this.onExportItemSelect.bind(this,item,index)}>
            <MenuItem eventKey={'0'}>ใบรายการรับเงิน</MenuItem>
            <MenuItem eventKey={'1'}>บิลเงินสด</MenuItem>            
          </DropdownButton>
          {showAdd?
          this.renderBtnDel(index)
          :''}
        </ButtonToolbar>  
      )
    }
  }

  renderRowData() {
    let {messages} = this.props
    let {data,optionsStatus} = this.state
    if (data.list===undefined||data.list.length===0) {
      return(<tr><td colSpan={5}>{messages['Data Not Found']}</td></tr>)
    } else {
      return(
        data.list.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'>
                <DatePicker
                  value={item.due_date}
                  selected={item.due_date}
                  onChange={this.onDateChange.bind(this,index)}
                  showIcon={true}
                  showFooter={true}
                  buddhistEra={true}
                />
              </td>
              <td className='text-center'>
                {/* <FormControl className='text-right' value={item.amount} onChange={this.onTextChange.bind(this,index,'amount')}></FormControl> */}
                <InputNumber
                  className='input-number-format text-right'
                  value={item.amount} 
                  onChange={this.onNumericChange.bind(this,index,'amount')}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                />
              </td>
              <td>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={item.status}
                  options={optionsStatus}
                  onChange={this.onStatusChange.bind(this,index)}
                />
              </td>
              <td className='text-center'>
                <FormControl value={item.remark} onChange={this.onTextChange.bind(this,index,'remark')}></FormControl>
              </td>
              <td className='text-center'>
                {this.renderPrintButton(item,index)}    
              </td>
            </tr>
          )
        })   
      )
    }  
  }

  renderSumary(){
    let {data,amount} = this.state
    let sum = 0,debt=amount
    let {messages} = this.props
    if (data.list===undefined||data.list.length===0) {
      return (<div/>)
    }

    data.list.map((item,index)=>{
      sum += item.amount*1
      if(item.status===1){
        debt -= item.amount*1
      }
      return item
    })

    let error = ''
    if(sum!==amount*1){
      let missAmount = amount - sum
      error = messages['Total Lack']+' '+this.getNumberFormat(missAmount)+' '+messages['Bath'] 
    }

    return (
      <tr>
            <td colSpan={2} className='text-right'>{messages['Total']} {this.getNumberFormat(sum)} {messages['Bath']} <span className='text-red'>{error}</span></td>
            <td colSpan={3} className='text-left'><span className='text-red'>{messages['Owe']} {this.getNumberFormat(debt)} {messages['Bath']}</span></td>
      </tr>
    )
  }

  renderAmount(){
    return (<span>{this.getNumberFormat(this.state.amount)}</span>)
}

  renderTable() {
    let {btnTitle,data} = this.state
    let {installationType} = data
    let {messages} = this.props
    return(
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center'>{messages['Installment']}</th>
            <th className='text-center' colSpan={2}>
              <DropdownButton id='dd-install' bsSize={'sm'} bsStyle={'primary'} title={btnTitle} onSelect={this.onMenuItemSelect.bind(this)}>
                <MenuItem eventKey={-1}>ไม่ระบุ</MenuItem>
                {
                  new Array(11).fill('').map((item,index)=>(
                    <MenuItem key={index} eventKey={index+2}>{(index+2)+' '+messages['Period']}</MenuItem>
                  ))
                }                
              </DropdownButton>
              &nbsp;
              แบ่งชำระแบบ
              &nbsp;
              <div style={{display:'inline-block'}}>
                <RadioGroup name="radio" value={installationType} onChange={this.onRadioChange.bind(this)}>
                  <Radio
                    value="same"
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Equal']}
                  />
                  <Radio
                    value="custom"
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Custom']}
                  />
                </RadioGroup>
              </div>
            </th>
            <th colSpan={2} className='text-center'>ยอดที่ต้องจ่าย {this.renderAmount()} {messages['Bath']}</th>
          </tr>
          <tr>
            <th className='text-center' >{messages['Day']}</th>
            <th className='text-center' style={{width:'135px'}}>{messages['Amount']}</th>
            <th className='text-center' style={{minWidth:'140px'}}>{messages['Status']}</th>
            <th className='text-center'>{messages['Note']}</th>
            <th className='text-center'>{'พิมพ์'}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          {this.renderSumary()}
        </tfoot>
      </table>
    )
  }  

  render(){
    let {loading,showPNDoc,showAdd} = this.state
    let {messages,uiSchema} = this.props
    return (
      
      <Box loading={loading}>
        {uiSchema===undefined
        ?<Box.Header >
        {messages['Credit Installment']}
        </Box.Header>
        :''          
        }  
        <Box.Body>
          {this.renderTable()}
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            {showAdd?
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;เพิ่มรายการ</Button>
            :''}
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
          </ButtonToolbar>
        </Box.Footer>
        <PaymentNoteDocModal ref='pnDocM' 
        show={showPNDoc} 
        onSaved={this.onPaymentNodeSaved.bind(this)}
        onHide={()=>{this.setState({showPNDoc:false})}}/>
        <NotificationSystem ref="notificationSystem" />
      </Box>
    )
  }
}


SWTCreditInstallment.defaultProps = {  
  amount: ''
}

export default SWTCreditInstallment = connect(
  (state) => ({messages: state.message.view.workdoc.SWTCreditInstallment}),null,null,{withRef:true}
)(SWTCreditInstallment);






// WEBPACK FOOTER //
// ./src/view/workdoc/SWTCreditInstallment.js